import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ImageMedium from './ImageMedium';
import ImageThumbs from './ImageThumbs';
import Lines from './Lines';
import Video from './Video';

const LeftSide = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    width: 100%;
  }
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 12px;
  width: 36%;
  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    width: 100%;
    margin-top: 12px;
  }
`;

const ThumbsWrapper = styled.div`
  display: flex;
  margin-bottom: 32px;
  ${props =>
    Array.isArray(props.images) &&
    props.images.length > 2 &&
    `
    @media (min-width: ${props => props.theme.deviceWidth.largePhone}) {
      justify-content: space-between;
    }
  `};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    flex-direction: column;
  }
`;

class Gallery extends Component {
  state = {
    imageNumber: 0
  };

  handleMouseOver = index => {
    this.setState(state => ({
      imageNumber: index
    }));
  };

  static propTypes = {
    images: PropTypes.array,
    lines: PropTypes.array,
    stepid: PropTypes.number,
    video: PropTypes.object
  };

  render() {
    const { images, video, stepid, lines } = this.props;
    return (
      <Wrapper>
        <LeftSide>
          {Array.isArray(images) && images.length > 0 ? (
            <ImageMedium
              altText={
                lines.length < 3
                  ? lines[0].text
                  : lines[this.state.imageNumber].text
              }
              src={images[this.state.imageNumber].medium}
              images={images}
              imageNumber={this.state.imageNumber}
            />
          ) : null}
          <Video stepid={stepid} video={video} />
        </LeftSide>
        <RightSide>
          {Array.isArray(images) && images.length > 1 ? (
            <ThumbsWrapper images={images}>
              <ImageThumbs
                handleMouseOver={this.handleMouseOver}
                images={images}
              />
            </ThumbsWrapper>
          ) : null}
          <Lines lines={lines} />
        </RightSide>
      </Wrapper>
    );
  }
}
// <ImageMedium altText={lines[this.state.imageNumber].text} src={images[this.state.imageNumber].medium} />

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Steps/Gallery.js